import type { RouteRecordRaw } from "vue-router";
import CanvassesPage from "./CanvassesPage.vue";
import CanvassLayout from "./CanvassLayout.vue";
import CanvassParticipantsPage from "./CanvassParticipantsPage.vue";
import CanvassStatsPage from "./CanvassStatsPage.vue";
import EditCanvassPage from "./EditCanvassPage.vue";
import NewCanvassPage from "./NewCanvassPage.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/canvasses",
    children: [
      {
        path: "",
        name: "canvasses",
        component: CanvassesPage,
      },
      {
        path: "new",
        name: "newCanvass",
        component: NewCanvassPage,
      },
      {
        path: ":id",
        name: "canvass",
        component: CanvassLayout,
        props: (route) => ({ id: route.params.id }),
        children: [
          {
            path: "",
            name: "editCanvass",
            component: EditCanvassPage,
          },
          {
            path: "stats",
            name: "canvassStats",
            component: CanvassStatsPage,
          },
          {
            path: "participants",
            name: "canvassParticipants",
            component: CanvassParticipantsPage,
          },
        ],
      },
    ],
  },
];

export default routes;
